import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { useDiagramContext } from '../Context/DiagramContext';
import DownloadProgressSnackbar from '../../../common/components/DownloadProgressSnackbar';

const DiagramNotifications: React.FC = () => {
  const {
    saveError,
    setSaveError,
    opportunityUpdated,
    setOpportunityUpdated,
    downloadProgressOpen,
    downloadProgress,
  } = useDiagramContext();

  return (
    <>
      {/* Save Error */}
      <Snackbar
        open={!!saveError}
        autoHideDuration={5000}
        onClose={() => setSaveError(null)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity="error" sx={{ width: '100%' }}>
          {saveError}
        </Alert>
      </Snackbar>

      {/* Opportunity Updated */}
      <Snackbar
        open={opportunityUpdated}
        autoHideDuration={3000}
        onClose={() => setOpportunityUpdated(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert severity="info" sx={{ width: '100%' }}>
          Opportunity updated
        </Alert>
      </Snackbar>

      {/* Download Progress */}
      <DownloadProgressSnackbar open={downloadProgressOpen} progress={downloadProgress} />
    </>
  );
};

export default DiagramNotifications;
